import React from 'react'

type Props = {
  value: string
  onChange: (v: string) => void
  required?: boolean
  placeholder?: string
  disabled?: boolean
}

function countWords(text: string): number {
  const t = String(text || '').replace(/\u00A0/g, ' ').trim()
  if (!t) return 0
  const tokens = t.match(/\S+/g)
  return tokens ? tokens.length : 0
}

export default function MicroTextComposer({
  value,
  onChange,
  required,
  placeholder = "Write your micro...",
  disabled,
}: Props) {
  const v = String(value || '')
  const words = countWords(v)
  const chars = v.length
  const empty = !v.trim()

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <div className="flex items-center justify-between gap-3">
        <div className="text-sm font-semibold text-white/90">Micro text</div>
        <div className="text-xs text-white/60">
          {words} words · {chars} chars
        </div>
      </div>
      <textarea
        value={v}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className={[
          'mt-3 w-full rounded-xl bg-neutral-950/40 border px-3 py-3 text-sm outline-none resize-y',
          disabled ? 'opacity-60' : '',
          required && empty ? 'border-red-500/40 focus:ring-2 focus:ring-red-500/30' : 'border-white/10 focus:ring-2 focus:ring-brand',
        ].join(' ')}
        rows={7}
      />
      {required && empty ? <div className="mt-2 text-xs text-red-300">Micro text is required.</div> : null}
    </div>
  )
}

